
import { defineComponent } from "vue";
import Analytics from "../utils/analytics";
import Header from "./global/Header.vue";
import Footer from "./global/Footer.vue";
import TextSource from "./cards/TextSource.vue";
import FileSource from "./cards/FileSource.vue";
import FukumojiSource from "./cards/FukumojiSource.vue";
import Target from "./cards/Target.vue";
import Result from "./cards/Result.vue";
import Tutorial from "./cards/Tutorial.vue";
import TabButton from "./inputs/TabButton.vue";
import TabGroup from "./inputs/TabGroup.vue";
import Space from "./global/Space.vue";
import Grid from "./global/Grid.vue";
import GridItem from "./global/GridItem.vue";
import Image from "./icons/Image.vue";
import Text from "./icons/Text.vue";
import Emoji from "./icons/Emoji.vue";
import "../css/destyle.css";
import Card from "./global/Card.vue";

export default defineComponent({
  components: {
    Card,
    TextSource,
    FileSource,
    FukumojiSource,
    Target,
    Result,
    Tutorial,
    TabButton,
    TabGroup,
    Header,
    Footer,
    Space,
    Grid,
    GridItem,
    Image,
    Text,
    Emoji,
  },
  data() {
    return {
      baseImage: null as (HTMLImageElement | HTMLCanvasElement | null),
      name: null as (string | null),
      emojiName: null as (string | null),
      resultImages: [[]] as Blob[][],
      previewMode: false,
      emojiSize: null as (number | null),
      /* Misskey連携用 */
      existingEmojis: [] as string[],
      registrationStatus: null as ('loading' | 'success' | 'error' | null),
      registrationMessage: '' as string,
      /* ui */
      ui: {
        mode: "text",
        showTargetPanel: true,
        showTargetDetails: false,
      },
    };
  },
  mounted() {
    Analytics.switchMode("text");
    // Misskeyからのメッセージを受信
    window.addEventListener('message', this.handleMisskeyMessage);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleMisskeyMessage);
  },
  methods: {
    handleMisskeyMessage(event: MessageEvent): void {
      try {
        // データが文字列の場合はパース、オブジェクトの場合はそのまま使用
        let data = event.data;
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }

        if (data && data.source === 'misskey-emoji-picker') {
          console.log('Received from Misskey:', data.type, data);

          if (data.type === 'emoji-list') {
            // 既存絵文字リストを受信
            this.existingEmojis = data.emojis || [];
            console.log('Emoji list updated:', this.existingEmojis.length, 'emojis');
          } else if (data.type === 'result') {
            // 登録結果を受信
            console.log('Registration result:', data);
            console.log('Before update - status:', this.registrationStatus, 'message:', this.registrationMessage);
            if (data.success) {
              this.registrationStatus = 'success';
              this.registrationMessage = `絵文字「${data.emojiName}」を登録しました！`;
              console.log('After update - status:', this.registrationStatus, 'message:', this.registrationMessage);
              // 3秒後にリセット
              setTimeout(() => {
                this.registrationStatus = null;
                this.registrationMessage = '';
              }, 3000);
            } else {
              this.registrationStatus = 'error';
              this.registrationMessage = data.error || '登録に失敗しました';
              console.log('After update (error) - status:', this.registrationStatus, 'message:', this.registrationMessage);
              // 5秒後にリセット
              setTimeout(() => {
                this.registrationStatus = null;
                this.registrationMessage = '';
              }, 5000);
            }
          }
        }
      } catch (e) {
        // 他のメッセージ（React DevToolsなど）は無視
      }
    },
    onToggleShowTarget(): void {
      this.ui.showTargetPanel = !this.ui.showTargetPanel;
      Analytics.switchMode(this.ui.showTargetPanel ? "target" : this.ui.mode, true);
    },
    onSelectMode(value: string): void {
      this.ui.mode = value;
      this.ui.showTargetPanel = false;
      Analytics.switchMode(value, true);
    },
    onRenderTarget(imgs: Blob[][]): void {
      this.resultImages = imgs;
      Analytics.render();
    },
    onRender(img: HTMLImageElement, name: string, emojiName: string): void {
      this.baseImage = img;
      this.name = name;
      this.emojiName = emojiName
    },
    setRegistrationLoading(): void {
      this.registrationStatus = 'loading';
      this.registrationMessage = '登録中...';
    },
  },
});
